// extracted by mini-css-extract-plugin
export default {"title":"c6fe4f0663","inner_title":"b31af5f8a1","charge_btn":"_08247318bd"};